import type { IconSvgElement } from "@hugeicons/react";
import {
  File02Icon,
  FilterIcon,
  IdentityCardIcon,
  PlazaIcon,
  SquareLock02Icon,
  UserCircleIcon
} from "@hugeicons-pro/core-stroke-rounded";
import type { MasterSearchEntityType } from "api/masterSearch";

export const MASTER_SEARCH_PLACEHOLDER = "Search by name, email, phone…";

export const MIN_QUERY_LENGTH = 2;

// Server caps at 10 per group; ask for the maximum so the palette truncates as
// little as possible (the group badge reports "N of total" either way).
export const MASTER_SEARCH_LIMIT = 10;

export const ENTITY_TYPE_LABELS: Record<MasterSearchEntityType, string> = {
  lead: "Leads",
  contact: "Contacts",
  screen_applicant: "Applicants",
  report_renter: "Renters",
  listing: "Listings",
  lockbox: "Lockboxes"
};

export const ENTITY_TYPE_ICONS: Record<MasterSearchEntityType, IconSvgElement> =
  {
    lead: FilterIcon,
    contact: IdentityCardIcon,
    screen_applicant: File02Icon,
    report_renter: UserCircleIcon,
    listing: PlazaIcon,
    lockbox: SquareLock02Icon
  };

export const ENTITY_TYPE_ORDER: MasterSearchEntityType[] = [
  "lead",
  "contact",
  "screen_applicant",
  "report_renter",
  "listing",
  "lockbox"
];
